var React = require('react');

var App = require('./app');

window.app = React.renderComponent(App(), document.body);



/*****************
 ** WEBPACK FOOTER
 ** ./src/main.js
 ** module id = 0
 ** module chunks = 0
 **/